import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCommissionsRatesList extends Layout {
    layoutheaderCommissionsRates: LayoutHeader;
    sourceCommissionRate: DataSource;
    tableCommissionsRates: Table;
}
